import React from 'react';

interface TokenomicsModalProps {
    onClose: () => void;
}

const TokenomicsModal: React.FC<TokenomicsModalProps> = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-funky-pink p-8 rounded-lg border-4 border-funky-green text-center max-w-2xl">
                <h2 className="text-4xl font-funky mb-6 text-funky-yellow">How Much Groove Can You Handle?</h2>
                <div className="space-y-4 text-left mb-6">
                    <div className="flex items-center">
                        <p className="text-funky-yellow text-xl"><span className="font-bold">40% Disco Supply:</span> For public dance floors (Public Sale).</p>
                    </div>
                    <div className="flex items-center">
                        <p className="text-white text-xl"><span className="font-bold">20% Panda Party Fund:</span> Because Disco Panda loves sharing the groove.</p>
                    </div>
                    <div className="flex items-center">
                        <p className="text-white text-xl"><span className="font-bold">10% Liquidity:</span>So that the party never stops!.</p>
                    </div>
                    <div className="flex items-center">
                        <p className="text-funky-blue text-xl"><span className="font-bold">20% DJ Reserve:</span> For developers (We pay our DJs well).</p>
                    </div>
                    <div className="flex items-center">
                        <p className="text-funky-green text-xl"><span className="font-bold">10% Airdrop:</span> To early party animals who got into $PANDA before it was cool.</p>
                    </div>
                </div>
                <button
                    className="px-6 py-3 bg-funky-yellow text-funky-pink rounded-full hover:bg-funky-blue hover:text-funky-yellow transition-all duration-300 font-bold text-xl"
                    onClick={onClose}
                >
                    Back to the Dance Floor!
                </button>
            </div>
        </div>
    );
};

export default TokenomicsModal;